import { useState, FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, TextField, Typography, Paper, Alert, CircularProgress, Divider, Chip, Snackbar } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { authService } from "@/api/auth.service";
import { useAuth } from "@/context/AuthContext";

export default function HouseholdPage() {
  const { refreshUser } = useAuth();
  const nav = useNavigate();
  const [householdName, setHouseholdName] = useState(""); const [inviteCode, setInviteCode] = useState(""); const [createdCode, setCreatedCode] = useState("");
  const [error, setError] = useState(""); const [loading, setLoading] = useState(false); const [snackOpen, setSnackOpen] = useState(false);

  const handleCreate = async (e: FormEvent) => {
    e.preventDefault(); setError(""); setLoading(true);
    try { const h = await authService.createHousehold(householdName); setCreatedCode(h.inviteCode); await refreshUser(); }
    catch (err: any) { setError(err.response?.data?.error || "Erreur."); }
    finally { setLoading(false); }
  };

  const handleJoin = async (e: FormEvent) => {
    e.preventDefault(); setError(""); setLoading(true);
    try { await authService.joinHousehold(inviteCode); await refreshUser(); nav("/dashboard"); }
    catch (err: any) { setError(err.response?.data?.error || "Code invalide."); }
    finally { setLoading(false); }
  };

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "grey.100", display: "flex", alignItems: "center", justifyContent: "center", p: 2 }}>
      <Box sx={{ width: "100%", maxWidth: 480, display: "flex", flexDirection: "column", gap: 3 }}>
        <Typography variant="h5" fontWeight={700} align="center">Mon Foyer</Typography>
        {error && <Alert severity="error">{error}</Alert>}
        <Paper elevation={2} sx={{ p: 3, borderRadius: 3 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}><HomeIcon color="primary" /><Typography variant="h6" fontWeight={600}>Créer un foyer</Typography></Box>
          {createdCode ? (
            <Box>
              <Alert severity="success" sx={{ mb: 2 }}>Foyer créé ! Partagez ce code :</Alert>
              <Box sx={{ display: "flex", gap: 1 }}><Chip label={createdCode} sx={{ fontSize: 16, flex: 1 }} /><Button startIcon={<ContentCopyIcon />} onClick={() => { navigator.clipboard.writeText(createdCode); setSnackOpen(true); }} variant="outlined" size="small">Copier</Button></Box>
              <Button fullWidth variant="contained" sx={{ mt: 2 }} onClick={() => nav("/dashboard")}>Accéder au tableau de bord</Button>
            </Box>
          ) : (
            <Box component="form" onSubmit={handleCreate} sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <TextField label="Nom du foyer" value={householdName} onChange={e => setHouseholdName(e.target.value)} required fullWidth />
              <Button type="submit" variant="contained" fullWidth disabled={loading}>{loading ? <CircularProgress size={22} color="inherit" /> : "Créer"}</Button>
            </Box>
          )}
        </Paper>
        <Divider><Typography variant="body2" color="text.secondary">ou</Typography></Divider>
        <Paper elevation={2} sx={{ p: 3, borderRadius: 3 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}><GroupAddIcon color="secondary" /><Typography variant="h6" fontWeight={600}>Rejoindre un foyer</Typography></Box>
          <Box component="form" onSubmit={handleJoin} sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <TextField label="Code d'invitation" value={inviteCode} onChange={e => setInviteCode(e.target.value)} required fullWidth />
            <Button type="submit" variant="outlined" color="secondary" fullWidth disabled={loading}>{loading ? <CircularProgress size={22} color="inherit" /> : "Rejoindre"}</Button>
          </Box>
        </Paper>
      </Box>
      <Snackbar open={snackOpen} autoHideDuration={2000} onClose={() => setSnackOpen(false)} message="Code copié !" />
    </Box>
  );
}
